import * as yup from "yup";

export const sharePostSchema = yup.object().shape({
    organization: yup.string().required('Organization is required.')
}).required();